export enum SiteReviewCheckEnums {
  OwnerNamesAndParcelIDsVerified = 'owner_names_and_parcel_ids_verified',
  GoogleEarthEngineChangeDetectionVerified = 'google_earth_engine_change_detection_verified',
  RestrictedConvenants = 'restricted_covenants',
  MapApproved = 'map_approved',
  AllSupportingDocumentsProvided = 'all_supporting_documents_provided',
  BuyerSpecificRequirementDocument = 'buyer_specific_requirement_document',
}
